var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": "BookingSelectList",
      "extra-items": [{
        text: _vm.presetName,
        to: 'BookingList',
        params: _vm.$route.params.id
      }, '店休設定']
    }
  })], 1)]), _c('b-card', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2 justify-content-between"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-8 mb-2 font-weight-bold"
  }, [_vm._v(_vm._s(_vm.presetName) + " 店休設定")])]), _c('div', {
    staticClass: "d-flex mb-4 mb-xl-2 justify-content-between"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('AppSingleSelect', {
    attrs: {
      "options": _vm.branchOptions
    },
    on: {
      "input": _vm.formatAndFetch
    },
    model: {
      value: _vm.branch,
      callback: function callback($$v) {
        _vm.branch = $$v;
      },
      expression: "branch"
    }
  })], 1), _c('div', {
    staticClass: "d-flex flex-column flex-md-row align-items-center"
  }, [_vm.checkPermission([_vm.consts.BOOKING_BRANCH_SHIFT_CREATE]) ? _c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-md-0 mr-md-2",
    attrs: {
      "variant": "primary",
      "to": {
        name: 'BookingBranchShiftCreate',
        query: {
          preset_id: _vm.preset_id,
          branch_id: _vm.query.branch_id
        }
      },
      "disabled": !_vm.query.branch_id
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("新增 ")]) : _vm._e(), _c('b-form-select', {
    staticClass: "mr-2",
    attrs: {
      "options": _vm.shiftTypeOptions
    },
    on: {
      "change": _vm.handlePageResetWithoutReload
    },
    model: {
      value: _vm.query.shift_type,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "shift_type", $$v);
      },
      expression: "query.shift_type"
    }
  }), _c('div', {
    staticClass: "d-flex align-items-stretch"
  }, [_c('DateSearchPicker', {
    staticClass: "mr-1",
    attrs: {
      "startedPlaceholder": "開始時間",
      "endedPlaceholder": "結束時間"
    },
    on: {
      "input": _vm.handleDateChange
    },
    model: {
      value: _vm.query,
      callback: function callback($$v) {
        _vm.query = $$v;
      },
      expression: "query"
    }
  }), _c('b-button', {
    staticStyle: {
      "height": "auto"
    },
    on: {
      "click": _vm.handlePageResetWithoutReload
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1)]), _c('b-card-text', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading,
      "rounded": "sm"
    }
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.bookingShifts,
      "fields": _vm.fields
    },
    scopedSlots: _vm._u([{
      key: "cell(actions)",
      fn: function fn(data) {
        return [_vm.checkPermission([_vm.consts.BOOKING_BRANCH_SHIFT_LIST_VIEW]) ? _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-primary",
            "to": {
              name: 'BookingBranchShiftView',
              params: {
                id: _vm.preset_id,
                shift_id: data.item.id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-eye"
        }), _vm._v(" 查看 ")]) : _vm._e(), _vm.checkPermission([_vm.consts.BOOKING_BRANCH_SHIFT_MODIFY]) ? _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-warning",
            "to": {
              name: 'BookingBranchShiftEdit',
              params: {
                id: _vm.preset_id,
                shift_id: data.item.id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-lead-pencil"
        }), _vm._v(" 編輯 ")]) : _vm._e(), _vm.checkPermission([_vm.consts.BOOKING_BRANCH_SHIFT_DELETE]) ? _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-danger"
          },
          on: {
            "click": function click($event) {
              return _vm.deleteBranchShift(data.item);
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-delete"
        }), _vm._v(" 刪除 ")]) : _vm._e()];
      }
    }])
  })], 1)], 1)]), _c('CustomPagination', {
    attrs: {
      "currentPage": _vm.query.page,
      "totalRows": _vm.totalRows,
      "perPage": _vm.query.per_page
    },
    on: {
      "page-change": _vm.handlePageChange,
      "per-page-change": _vm.handlePerPageChange
    }
  })], 1)], 1), _c('FormUrlModal', {
    ref: "formUrlModal"
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }